// 专供客户端ajax请求使用
import axios from 'axios'
import app from '@/main'
import store from '@/store'
import { getDeviceType } from '@/utils/detect'
import { getTouristsVal, getTouristsToken, removeTouristsToken, removeRealTouristsToken } from '@/utils'
import errorTips from '@/assets/json/errorTips'

const getPlatformType = () => {
  const result = getDeviceType()
  return (result === 'PC' ? 'web' : 'h5')
}
// 使用设备类型
axios.defaults.headers.common['Platform'] = getPlatformType()
axios.defaults.validateStatus = function(status) {
  return status >= 200 && status <= 204 // default
}

// 排除相关url进行判断
const ignoreUrl = [
  '/home/sites/user/info',
  '/submitter/config/module'
]

/**
 *
 * @param {string} url 请求路径
 * @param {object} data 请求参数对象
 * @param {object} option 非axios的配置参数
 * @param {boolean} option.ignoreMsg 是否忽略错误弹窗，改为自行捕获
 * @param {boolean} option.ignoreToken 是否忽略token传递
 * @param {boolean} option.loading 是否在请求时使用loading
 * @param {object} config 提供给axios的配置参数 https://github.com/axios/axios
 */
const ajax = (type, apiKey = 'api_exam') => async (
  url,
  data = {},
  { ignoreMsg = false, ignoreToken = false, loading = false } = {},
  ext = { timeout: 20000 }
) => {
  const isTourists = getTouristsVal()
  const touristsToken = getTouristsToken()
  const isIgnoreUrl = ignoreUrl.includes(url)
  const config = {}
  if (!ignoreToken && !isTourists) {
    config.withCredentials = true
  }
  if (isTourists && !isIgnoreUrl && (apiKey === 'api_exam' || apiKey === 'tart_api')) {
    if (apiKey === 'api_exam') {
      url = '/anonymous' + url
    }
    if (touristsToken) {
      config.headers = {
        Authorization: touristsToken,
        Authorization_Type: 3
      }
    }
  }
  Object.assign(config, ext)
  config.url = /^http/.test(url) ? url : CONFIG[apiKey] + url
  config.method = type
  if (['put', 'post', 'patch'].includes(type)) {
    config.data = data
  }
  if (type === 'get') {
    config.params = Object.assign({}, data)
    config.params.TIME = +new Date()
  }
  try {
    const res = await axios(config)
    return res.data
  } catch (error) {
    const response = error.response
    let errorCode
    let errorMessage
    if (response) {
      const data = response.data
      errorCode = data.error_code || data.status
      errorMessage =
        data.error_message ||
        data.message ||
        errorTips[errorCode] ||
        data.error_msg ||
        `未定义错误号 ${errorCode} 的错误提示`
      if (errorCode === 100010 || errorCode === 20601005 || errorCode === 20601003) {
        if (isTourists) {
          removeTouristsToken()
          removeRealTouristsToken()
          const _path = window.location.pathname
          const path = sessionStorage.getItem('path')
          const goPath = `/${path}/list`
          if (_path !== goPath) {
            window.location.href = goPath
          }
        } else {
          if (!app.$route.meta || !app.$route.meta.dialogLogin) {
            await store.dispatch('logout')
            store.commit('LOGOUT')
            return
          }
        }
      // 未开始、已结束 or 整场终止 or 换考
      } else if ([20612006, 20612004, 20612005].includes(errorCode) && !ignoreMsg) {
        app.$message({
          type: 'warning',
          message: errorMessage
        })
        if (!app.isNemoApp) {
          const path = sessionStorage.getItem('path')
          app.$router.replace(`/${path}/list`)
        }
        return Promise.reject()
      }
    } else {
      errorMessage = error.message
      errorCode = error.status || 0
    }
    if (errorMessage === 'Network Error') {
      errorMessage = '你已断网，请检测网络设置'
    } else if (errorMessage.includes('timeout of')) {
      errorMessage = '网络请求超时，请稍后重试'
    }
    if (!ignoreMsg) app.$message(errorMessage)
    return Promise.reject({ error_code: errorCode, error_msg: errorMessage, url })
  }
}

// 第二个参数为配置的域名alias
export const kittenGet = ajax('get', 'kitten')
export const eduGet = ajax('get', 'api_edu')
export const get = ajax('get')
export const post = ajax('post')
export const put = ajax('put')
export const patch = ajax('patch')
export const del = ajax('delete')

export const tartApiGet = ajax('get', 'tart_api')
export const tartApiPost = ajax('post', 'tart_api')
